import { SchemaWithMigrations, } from '@dossierhq/core';
import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
export function useAdminSchema(client) {
    const fetcher = useCallback((_action) => fetchSchema(client), [client]);
    const { data, error } = useSWR(CACHE_KEYS.schema, fetcher);
    // useDebugLogChangedValues('useAdminSchema changed values', { data, error });
    return { schema: data, schemaError: error };
}
async function fetchSchema(client) {
    const result = await client.getSchemaSpecification({
        includeMigrations: true,
    });
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return new SchemaWithMigrations(result.value);
}
//# sourceMappingURL=useAdminSchema.js.map